

import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MenuPermissionService } from '../../../core/services/menu-permission.service';
import { Menu, Permission } from '../../../core/models/menu-permission.model';
import { SchemaApiService } from '../../../core/services/schema-api.service';
import { LookupDto, ModuleService } from '../../../core/services/module.service';

@Component({
      selector: 'app-menu-permission',
      standalone: true,
      imports: [CommonModule, FormsModule],
      templateUrl: './menu-permission.component.html'
})
export class MenuPermissionComponent implements OnInit {
      menus: Menu[] = [];
      parentMenus: Menu[] = [];
      allPermissions: Permission[] = [];
      selectedMenu: Menu | null = null;
      loading: boolean = false;

      // 1. Add these state variables inside your class
      parentSearch: string = '';
      showParentDropdown: boolean = false;

      // Form State
      showForm = false;
      menuModel: Menu = this.resetMenu();

      // --- New Organization State ---
      organisations: any[] = [];
      orgSearch: string = '';
      showOrgDropdown: boolean = false;

      // --- New Cascading State ---
      modules: LookupDto[] = [];
      entities: LookupDto[] = [];
      entitySearch: string = '';
      showEntityDropdown: boolean = false;

      constructor(private api: MenuPermissionService, private orgApi: SchemaApiService, private moduleService: ModuleService) { }

      ngOnInit() {
            this.loadInitialData();
            this.loadModules();
      }

      // resetMenu(): Menu {
      //       this.parentSearch = '';
      //       this.orgSearch = ''; // Reset search text
      //       this.entitySearch = ''; // Clear search
      //       return { id: '', name: '', code: '', route: '', icon: '', isActive: true, orgId: null, moduleCode: null, entityId: null };
      // }
      resetMenu(): Menu {
            this.parentSearch = '';
            this.orgSearch = ''; // Reset search text
            this.entitySearch = ''; // Clear search
            return {
                  id: '',
                  name: '',
                  code: '',
                  description: '',
                  route: '',
                  icon: '',
                  isActive: true,
                  orgId: null,
                  moduleCode: null,
                  moduleId: null,   // Explicitly track ID
                  moduleName: '',   // <-- ADD THIS LINE
                  entityId: null
            };
      }
      // Fetch Orgs from API
      onOrgSearch() {
            if (this.orgSearch.length < 1) {
                  this.organisations = [];
                  return;
            }
            // Using your existing service method
            this.orgApi.getOrgSuggestions(this.orgSearch).subscribe(res => {
                  this.organisations = res;
                  this.showOrgDropdown = true;
            });
      }
      selectOrg(org: any) {
            if (org) {
                  this.menuModel.orgId = org.id;   // Store the UUID
                  this.orgSearch = org.name;      // Show Name in input
            } else {
                  this.menuModel.orgId = null;
                  this.orgSearch = '';
            }
            this.showOrgDropdown = false;
      }

      loadModules() {
            this.moduleService.getModules().subscribe(res => this.modules = res);
      }



      // onModuleChange() {
      //       // 1. Reset Entity when module changes
      //       this.menuModel.entityId = null;
      //       this.entitySearch = '';
      //       this.entities = [];

      //       if (this.menuModel.moduleCode) {
      //             // 2. Find the actual Module Object to get the GUID (moduleId)
      //             const selectedModule = this.modules.find(m => m.code === this.menuModel.moduleCode);
      //             if (selectedModule) {
      //                   this.menuModel.moduleId = selectedModule.id; // Store the GUID for the database
      //                   console.log("Module Selected ID:", this.menuModel.moduleId);
      //             }

      //             // 3. Fetch entities for this module
      //             this.moduleService.getEntitiesByModule(this.menuModel.moduleCode).subscribe(res => {
      //                   this.entities = res;
      //             });
      //       } else {
      //             this.menuModel.moduleId = null;
      //       }
      // }
      onModuleChange() {
            // 1. Reset Entity when module changes
            this.menuModel.entityId = null;
            this.entitySearch = '';
            this.entities = [];

            if (this.menuModel.moduleCode) {
                  // 2. Find the actual Module Object to get the GUID and Name
                  const selectedModule = this.modules.find(m => m.code === this.menuModel.moduleCode);
                  if (selectedModule) {
                        this.menuModel.moduleId = selectedModule.id;
                        this.menuModel.moduleName = selectedModule.name; // <-- ADD THIS LINE (Make sure 'name' matches your LookupDto property)
                        console.log("Module Selected:", selectedModule);
                  }

                  // 3. Fetch entities for this module
                  this.moduleService.getEntitiesByModule(this.menuModel.moduleCode).subscribe(res => {
                        this.entities = res;
                  });

                  //
                  this.api.getParentMenus(this.menuModel.moduleId || '').subscribe(res => this.parentMenus = res);

            } else {
                  this.menuModel.moduleId = null;
                  this.menuModel.moduleName = ''; // <-- ADD THIS LINE
            }
      }
      loadInitialData() {
            this.api.getMenus().subscribe(res => this.menus = res);
            this.api.getPermissions().subscribe(res => {
                  this.allPermissions = res.map(p => ({ ...p, id: p.id!, isAssigned: false }));
            });
      }

      // Logic to filter the dropdown list
      get filteredParentMenus() {
            const search = (this.parentSearch || '').toLowerCase().trim();

            // Always exclude self
            let availableMenus = this.parentMenus.filter(m => m.id !== this.menuModel.id);

            if (!search) return availableMenus;

            // If search matches the current selected name, still show options 
            // but maybe filtered by that name so the user can see what's selected.
            return availableMenus.filter(m =>
                  m.name.toLowerCase().includes(search) ||
                  m.code.toLowerCase().includes(search)
            );
      }
      get filteredEntities() {
            const search = (this.entitySearch || '').toLowerCase().trim();
            if (!search) return this.entities;
            return this.entities.filter(e =>
                  e.name.toLowerCase().includes(search) ||
                  e.code.toLowerCase().includes(search)
            );
      }
      selectEntity(entity: LookupDto | null) {
            if (entity) {
                  this.menuModel.entityId = entity.id;
                  this.entitySearch = entity.name;
            } else {
                  this.menuModel.entityId = null;
                  this.entitySearch = '';
            }
            this.showEntityDropdown = false;
      }

      // 4. Handle selecting an item from the autocomplete list
      selectParent(menu: Menu | null) {
            if (menu) {
                  this.menuModel.parentId = menu.id; // Stores the UUID
                  this.parentSearch = menu.name;     // Shows the Name in the input box
            } else {
                  this.menuModel.parentId = null;
                  this.parentSearch = '';
            }
            this.showParentDropdown = false;
      }

      selectMenu(menu: Menu) {
            this.selectedMenu = menu;
            this.loading = true;
            this.api.getAssignedPermissions(menu.id).subscribe(assignedIds => {
                  this.allPermissions.forEach(p => p.isAssigned = assignedIds.includes(p.id));
                  this.loading = false;
            });
      }

      // CRUD Actions
      openCreate() {
            this.menuModel = this.resetMenu();
            this.showForm = true;
      }


      // openEdit(menu: Menu, event: Event) {
      //       if (event) event.stopPropagation();

      //       this.menuModel = { ...menu };

      //       // If ParentName exists from our SQL Join, show it. 
      //       // Otherwise, it's a Top Level node.
      //       if (this.menuModel.parentName) {
      //             this.parentSearch = this.menuModel.parentName;
      //       } else {
      //             this.parentSearch = '';
      //       }
      //       this.entitySearch = this.menuModel.entityName || '';

      //       // Load entities for the existing module if applicable
      //       if (this.menuModel.moduleCode) {
      //             this.moduleService.getEntitiesByModule(this.menuModel.moduleCode).subscribe((res: any) => {
      //                   this.entities = res;
      //             });
      //       }
      //       this.orgSearch = this.menuModel.orgName || '';
      //       this.showOrgDropdown = false;
      //       this.entitySearch = this.menuModel.entityName || '';
      //       this.showForm = true;
      //       this.showParentDropdown = false;
      // }


      // openEdit(menu: Menu, event: Event) {
      //       if (event) event.stopPropagation();

      //       this.menuModel = { ...menu };

      //       // Set search strings for the UI
      //       this.parentSearch = this.menuModel.parentName || '';
      //       this.orgSearch = this.menuModel.orgName || '';
      //       this.entitySearch = this.menuModel.entityName || '';

      //       // Load entities if we have a module code
      //       if (this.menuModel.moduleCode) {
      //             this.moduleService.getEntitiesByModule(this.menuModel.moduleCode).subscribe((res: any) => {
      //                   this.entities = res;
      //             });
      //       }

      //       this.showForm = true;
      //       this.showOrgDropdown = false;
      //       this.showParentDropdown = false;
      //       this.showEntityDropdown = false;
      // }

      openEdit(menu: Menu, event: Event) {
            if (event) event.stopPropagation();

            this.menuModel = { ...menu };

            // Automatically find module details based on the existing code
            const currentModule = this.modules.find(m => m.code === this.menuModel.moduleCode);
            if (currentModule) {
                  this.menuModel.moduleId = currentModule.id;
                  this.menuModel.moduleName = currentModule.name;

                  //
                  this.api.getParentMenus(this.menuModel.moduleId || '').subscribe(res => this.parentMenus = res);
            }

            // Set search strings for the UI
            this.parentSearch = this.menuModel.parentName || '';
            this.orgSearch = this.menuModel.orgName || '';
            this.entitySearch = this.menuModel.entityName || '';

            // Load entities if we have a module code
            if (this.menuModel.moduleCode) {
                  this.moduleService.getEntitiesByModule(this.menuModel.moduleCode).subscribe((res: any) => {
                        this.entities = res;
                  });
            }

            this.showForm = true;
            this.showOrgDropdown = false;
            this.showParentDropdown = false;
            this.showEntityDropdown = false;
      }

      deleteMenu(id: string, event: Event) {
            event.stopPropagation(); // Prevents row click

            if (confirm('Are you sure you want to delete this node?')) {
                  this.api.deleteMenu(id).subscribe({
                        next: () => {
                              this.loadInitialData(); // Refresh list after delete
                        },
                        error: (err) => {
                              // If the backend sends a custom message, this shows it
                              const errorMsg = err.error?.message || err.message;
                              alert("Delete failed: " + errorMsg);
                        }
                  });
            }
      }

      // saveMenu() {

      //       // 1. Client-side Validation Check
      //       // We check for IDs specifically because search strings (like orgSearch) 
      //       // are just for the UI, but the DB needs the GUIDs.
      //       if (!this.menuModel.orgId || !this.menuModel.moduleCode || !this.menuModel.name || !this.menuModel.code || !this.menuModel.route) {
      //             alert("Please fill in all required fields (Organization, Module, Name, Code and Route).");
      //             return;
      //       }

      //       const isUpdate = !!this.menuModel.id && this.menuModel.id !== '';

      //       let payload: any;

      //       if (isUpdate) {
      //             // For Update: Send everything including the ID
      //             payload = { ...this.menuModel };

      //       } else {
      //             // For Create: Destructure and remove the ID property entirely
      //             const { id, ...data } = this.menuModel;
      //             payload = data; // Backend sees no 'id' field, so validation passes
      //       }
      //       // Console log here to verify moduleId and entityId exist before sending
      //       // console.log("Sending Payload:", payload);

      //       const action = isUpdate
      //             ? this.api.updateMenu(payload)
      //             : this.api.createMenu(payload);

      //       action.subscribe({
      //             next: () => {
      //                   this.loadInitialData();
      //                   this.goBack();
      //             },
      //             error: (err) => {
      //                   console.error("API Error:", err);
      //                   if (err.status === 400) {
      //                         // This will show you exactly which field failed in the console
      //                         console.error("Validation Details:", err.error.errors);
      //                         alert("Validation Failed. Check console for details.");
      //                   }
      //             }
      //       });
      // }


      // saveMenu() {
      //       // 1. Client-side Validation Check
      //       if (!this.menuModel.orgId || !this.menuModel.moduleCode || !this.menuModel.name || !this.menuModel.code || !this.menuModel.route) {
      //             alert("Please fill in all required fields (Organization, Module, Name, Code and Route).");
      //             return;
      //       }

      //       const isUpdate = !!this.menuModel.id && this.menuModel.id !== '';
      //       let payload: any;

      //       // Ensure we have a fallback for moduleName even if dropdown wasn't interacted with
      //       const currentModule = this.modules.find(m => m.code === this.menuModel.moduleCode);
      //       const resolvedModuleName = this.menuModel.moduleName || (currentModule ? currentModule.name : '');

      //       if (isUpdate) {
      //             // For Update: Send everything including the ID
      //             payload = { ...this.menuModel };
      //       } else {
      //             // For Create: Destructure and remove the ID property entirely
      //             const { id, ...data } = this.menuModel;
      //             payload = data;
      //       }

      //       // 2. CRITICAL STEP: Inject both casings to satisfy strict C# Model State validations
      //       payload.moduleName = resolvedModuleName;
      //       payload.ModuleName = resolvedModuleName;

      //       const action = isUpdate
      //             ? this.api.updateMenu(payload)
      //             : this.api.createMenu(payload);

      //       action.subscribe({
      //             next: () => {
      //                   this.loadInitialData();
      //                   this.goBack();
      //             },
      //             error: (err) => {
      //                   console.error("API Error:", err);
      //                   if (err.status === 400) {
      //                         console.error("Validation Details:", err.error?.errors);
      //                         alert("Validation Failed. Check console for details.");
      //                   } else {
      //                         alert("An unexpected backend error occurred.");
      //                   }
      //             }
      //       });
      // }

      saveMenu() {
            if (!this.menuModel.orgId || !this.menuModel.moduleCode || !this.menuModel.name || !this.menuModel.code || !this.menuModel.route) {
                  alert("Please fill in all required fields.");
                  return;
            }

            const isUpdate = !!this.menuModel.id && this.menuModel.id !== '';

            const currentModule = this.modules.find(m => m.code === this.menuModel.moduleCode);
            const resolvedModuleName = this.menuModel.moduleName || (currentModule ? currentModule.name : '');

            // Base fields that map to your public.sys_menu table and DTO properties
            const cleanData = {
                  name: this.menuModel.name,
                  code: this.menuModel.code,
                  description: this.menuModel.description,
                  route: this.menuModel.route,
                  icon: this.menuModel.icon,
                  isActive: this.menuModel.isActive,
                  orgId: this.menuModel.orgId,
                  moduleCode: this.menuModel.moduleCode,
                  moduleId: this.menuModel.moduleId || (currentModule ? currentModule.id : null),
                  moduleName: resolvedModuleName,
                  ModuleName: resolvedModuleName, // Case safety fallback
                  entityId: this.menuModel.entityId,
                  parentId: this.menuModel.parentId,
                  orderNo: (this.menuModel as any).orderNo || 0 // Mapped to your backend @OrderNo string
            };

            // CRITICAL: Ensure 'id' is attached inside the body payload object during updates
            let payload: any;
            if (isUpdate) {
                  payload = { id: this.menuModel.id, ...cleanData };
            } else {
                  payload = cleanData;
            }

            const action = isUpdate
                  ? this.api.updateMenu(payload)
                  : this.api.createMenu(payload);

            action.subscribe({
                  next: () => {
                        this.loadInitialData();
                        this.goBack();
                  },
                  error: (err) => {
                        console.error("API Error:", err);
                        if (err.status === 400) {
                              console.error("Validation Details:", err.error?.errors);
                              alert("Validation Failed. Check console for details.");
                        } else {
                              alert(`Error (${err.status}): Processing failed.`);
                        }
                  }
            });
      }
      savePermissions() {
            if (!this.selectedMenu) return;
            const payload = {
                  menuId: this.selectedMenu.id,
                  permissionIds: this.allPermissions.filter(p => p.isAssigned).map(p => p.id)
            };
            this.api.saveMapping(payload).subscribe(res => alert('Mapping Saved!'));
      }

      toggleAll(status: boolean) {
            this.allPermissions.forEach(p => p.isAssigned = status);
      }
      goBack() {
            this.showForm = false;
            this.selectedMenu = null;
            this.menuModel = this.resetMenu(); // Important to reset
      }
}